import { render, staticRenderFns } from "./CMLocationItem.vue?vue&type=template&id=8e148b16&scoped=true&lang=pug"
import script from "./CMLocationItem.vue?vue&type=script&lang=js"
export * from "./CMLocationItem.vue?vue&type=script&lang=js"
import style0 from "./CMLocationItem.vue?vue&type=style&index=0&id=8e148b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e148b16",
  null
  
)

export default component.exports